
import TableList from "@components/templates/tablelist";
import { HttpWayfailList, HttpUpdateWayfailStatus, HttpIgnoreWayfail, HttpRetryWayfail, HttpforceRetryWayfail, HttpAppendWayfail, HttpsetErrorWayfail,HttpRebuyWayfair } from "@/service/sfp/sfp";
import { mapState, mapGetters } from "vuex";
import comIndex from './update'
export default {
    components:{
        comIndex
    },
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    EQ_orderStatus: null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpWayfailList,
        interceptRequest(params) {
            const search = params.search,
            createdAt = (search.GE_createdAt || "").split('~'),
            latestShipDate = (search.GE_latestShipDate || "").split('~');
            search.GE_createdAt = createdAt[0];
            search.LE_createdAt = createdAt[1];
            search.GE_latestShipDate = latestShipDate[0];
            search.LE_latestShipDate = latestShipDate[1];
            return params;
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                // case 'queryOrder':
                // const url = this.$router.resolve({
                //     name: 'b2cOrderupdate',
                //     params: { type: 'query' },
                //     query: { id: params, nodeid: nodeid },
                // });
                // window.open(url.href, '_blank');
                // break;
                case "edit":
                    this.$router.push({
                        name: 'sfpWayfailUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case 'query':
                    this.operate = {
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids: params,
                        querytype:'query',
                        title:'查看',
                        showFooter: false,
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "sfpWayfailUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "retry":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params },
                        title: "重推操作",
                        ajaxRequest: HttpRetryWayfail
                    }
                    break;
                case "forceRetry":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        width: 500,
                        params: { id: params },
                        title: "强制重推",
                        desc:'点击后将生成新订单（原单号前+new）推送给仓库，请谨慎操作！确认强制重推？',
                        ajaxRequest: HttpforceRetryWayfail
                    }
                    break;
                case "ignore":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params },
                        title: "忽略操作",
                        ajaxRequest: HttpIgnoreWayfail
                    }
                    break;
                case "abnormal":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { ids: params },
                        title: "提交异常",
                        cancelText: '取消',
                        confirmText: '确定',
                        ajaxRequest: HttpsetErrorWayfail,
                        formdata: [
                            {
                                tag: "vSelect",
                                key: "status",
                                options:[{
                                    value:1,
                                    label:'购买异常'
                                },
                                {
                                    value:3,
                                    label:'推送异常'
                                }],
                                span: 24,
                                label: "选择异常",
                                labelWidth: 90,
                            },
                            {
                                tag: "vTextarea",
                                key: "errorCause",
                                span: 24,
                                label: "备注",
                                labelWidth: 90,
                            }
                        ]
                    }
                    break;
                case "append":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: "批量补单操作",
                        ajaxRequest: HttpAppendWayfail
                    }
                    break;
                case "allpurchase":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: "批量购买操作",
                        params: {
                            status: 1,
                            ids: params
                        },
                        ajaxRequest: HttpUpdateWayfailStatus
                    }
                    break;
                case "purchase":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        width: 500,
                        params: {
                            status: 1,
                            ids: params
                        },
                        title: "面单购买",
                        desc: "点击确定后将请求购买面单，确定？",
                        cancelText: '取消',
                        confirmText: '确定',
                        ajaxRequest: HttpUpdateWayfailStatus,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "cancelCause",
                                span: 24,
                                label: "备注",
                                required: false,
                                labelWidth:90,
                            }
                        ]
                    }
                    break;
                case "repurchase":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        width: 500,
                        params: {
                            id: params
                        },
                        title: "重新购买",
                        desc: "点击确定后将重新购买面单，购买成功后，会在原单号前加new自动推送仓库，确定？",
                        cancelText: '取消',
                        confirmText: '确定',
                        ajaxRequest: HttpRebuyWayfair,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "rebuyCause",
                                span: 24,
                                label: "备注",
                                required: false,
                                labelWidth:90,
                            }
                        ]
                    }
                    break;
                case "cancelorder":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: {
                            status: 4,
                            ids: params
                        },
                        title: "面单取消",
                        width: 500,
                        desc: "点击确定后仅取消面单，已推送到仓库的出库单，需要在仓库手动取消。确定取消？",
                        cancelText: '暂不取消',
                        confirmText: '确定',
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "cancelCause",
                                span: 24,
                                label: "取消原因",
                                required: false,
                                labelWidth:90,
                            }
                        ],
                        ajaxRequest: HttpUpdateWayfailStatus,
                    };
                    break;
                case 'export':
                    const formData=this.interceptRequest({search:{...this.formData.search}});
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/dropShipOrderPackage/exportOrderPackage', formData, {
                        executor: 'request',
                        download: true,
                        fileName: "Wayfail面单记录.xls"
                    }).catch(err => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true
                        });
                    });
                    break;
                case 'download':
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/dropShipOrderPackage/download', { ids: params }, {
                        executor: 'request',
                        download: true,
                        fileName: "download.zip"
                    }).then(data=>{
                        this.updateList()
                    }).catch(err => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true
                        });
                    });
                    break;
                case 'print':
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/dropShipOrderPackage/printed', { ids: params }, {
                        executor: 'request',
                        print: true,
                        fileType: "application/pdf"
                    }).then(data=>{
                        this.updateList()
                    }).catch(err => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true
                        });
                    });
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, orderStatus, errorStatus } = row,
                error = errorStatus === 'buyError' || errorStatus === 'cancelError' || errorStatus === 'pushError' || errorStatus === 'updateError';
            return [{
                label: '查看详情',
                show: true,
                params: id,
                operate: 'query'
            }, {
                label:'提交购买',
                show: orderStatus === 'establish',
                params: id,
                operate: 'purchase'
            },
            //     {
            //     label: '重新购买',
            //     show:  orderStatus==='close',
            //     params: id,
            //     operate: 'repurchase'
            // },

                {
                label: '编辑面单',
                show: orderStatus === 'establish' || errorStatus === 'buyError' || errorStatus === 'pushError' || orderStatus==='close',
                params: id,
                operate: 'edit'
            }, {
                label: '打印面单',
                show: orderStatus === 'printed' || orderStatus === 'purchased',
                params: id,
                operate: 'print'
            }, {
                label: '取消',
                show: orderStatus === 'printed' || orderStatus === 'purchased' || orderStatus === 'establish' || orderStatus === 'submit',
                params: id,
                operate: 'cancelorder'
            }, {
                label: '重推',
                show: error,
                params: id,
                operate: 'retry'
            },
            {
                label: '强制重推',
                show: errorStatus === 'pushError',
                params: id,
                operate: 'forceRetry'
            },
            {
                label: '忽略',
                show: error,
                params: id,
                operate: 'ignore'
            }]
        },
    },
    computed: {
        ...mapState('boss', ['accounts', 'products']),
        ...mapGetters('boss', ['otherWarehouses']),
        orderStatus() {
            return [
                {
                    value: 'establish',
                    label: '已创建',
                    theme: 'info',
                },
                {
                    value: 'submit',
                    label: '已提交',
                    theme: 'warning',
                },
                {
                    value: 'purchased',
                    label: '已购买',
                    theme: 'success'
                },
                {
                    value: 'printed',
                    label: '已打印',
                    theme: 'info'
                },
                {
                    value: 'close',
                    label: '已取消',
                    theme: 'error',
                },
            ];
        },
        TabsData() {
            return [
                {
                    name: "所有",
                    key: 'EQ_orderStatus',
                    val: null
                }, {
                    name: "待提交",
                    key: 'EQ_orderStatus',
                    val: "establish"
                }, {
                    name: "待打印",
                    key: 'EQ_orderStatus',
                    val: "purchased"
                }, {
                    name: "异常",
                    key: "NE_errorStatus",
                    val: "normal"
                }
            ]
        },
        ToolsData() {
            return [
                {
                    name: "批量购买",
                    operate: "allpurchase",
                    theme: "primary",
                    batch: true,
                },
                {
                    name: "所选条件导出",
                    operate: "export",
                    theme: "success",
                },
                {
                    name: "批量打印",
                    operate: "print",
                    more: true,
                    batch: true,
                },
                {
                    name: "批量下载",
                    operate: "download",
                    more: true,
                    batch: true,
                },
                {
                    name: "批量取消",
                    operate: "cancelorder",
                    more: true,
                    batch: true,
                },
                {
                    name: "批量补单",
                    operate: "append",
                    more: true,
                    batch: true,
                },
                // {
                //     name: "批量忽略",
                //     operate: "ignore",
                //     more: true,
                // },
                {
                    name: "批量提交异常",
                    operate: "abnormal",
                    more: true,
                    batch: true,
                },

            ]
        },
        SearchsData() {
            const accounts = this.accounts.map((item) => {
                const { id, title, flag } = item;
                return {
                    value: flag,
                    label: flag
                }
            }),
                dropStyle = "width:auto;min-width:186px;";
            return [
                {
                    label: "仓库",
                    tag: 'vSelect',
                    key: 'EQ_orgWarehouseId',
                    show: true,
                    options: this.otherWarehouses.map(function (item) {
                        const { id, title } = item;
                        return {
                            value: id,
                            label: title
                        }
                    }),
                    props: {
                        dropStyle,
                        filterable: true,
                    }
                },
                {
                    label: "平台订单号",
                    tag: 'vInput',
                    key: 'CN_orderNo',
                    show: true,
                },

                {
                    label: "面单ID",
                    tag: 'vInput',
                    key: 'CN_surfaceId',
                    show:true,
                },
                {
                    label: "平台账号",
                    tag: 'vSelect',
                    key: 'EQ_sourceChannel',
                    // show: true,
                    options: accounts,
                    props: {
                        dropStyle,
                        filterable: true,
                    }
                },
                {
                    label: "项目",
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options: this.products.map(function (item) {
                        const { id, name } = item;
                        return {
                            value: id,
                            label: name
                        }
                    }),
                    props: {
                        dropStyle,
                        filterable: true,
                    }
                },

                {
                    label: "Seller SKU",
                    tag: 'vInput',
                    key: 'EQ_orderPackageItemList.sellerSku',
                },

                {
                    label: "ERP SKU",
                    tag: 'vInput',
                    key: 'EQ_orderPackageItemList.erpSku',
                    // options:[],
                },
                {
                    label: "承运商服务",
                    tag: 'vInput',
                    key: "EQ_carrierService",
                    // options: []
                },
                {
                    label: "Tracking NO",
                    tag: 'vInput',
                    key: 'CN_trackingNo',
                },
                {
                    label: "异常",
                    tag: 'vSelect',
                    key: 'IN_errorStatus',
                    options: [
                        {
                            value: 'normal',
                            label: '无异常 '
                        },
                        {
                            value: 'pushError',
                            label: '推送异常'
                        },
                        {
                            value: 'buyError',
                            label: '购买异常'
                        },
                        {
                            value: 'cancelError',
                            label: '取消异常'
                        },
                        {
                            value: 'updateError',
                            label: '更新异常'
                        },
                    ],
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: "单据状态",
                    tag: 'vSelect',
                    key: 'IN_orderStatus',
                    formatter(value) {
                        return (value || []).join(',')
                    },
                    style: "width:362px",
                    props: {
                        multiple: true,
                        dropStyle,
                        filterable:true,
                    },
                    options: [
                        {
                            value: 'establish',
                            label: '已创建',
                        },
                        {
                            value: 'submit',
                            label: '已提交',

                        },
                        {
                            value: 'purchased',
                            label: '已购买',
                        },
                        {
                            value: 'printed',
                            label: '已打印',
                        },
                        {
                            value: 'close',
                            label: '已取消',
                        },
                    ],
                },
                {
                    label: "物流状态",
                    tag: 'vSelect',
                    key: 'IN_logisticStatus',
                    formatter(value) {
                        return (value || []).join(',')
                    },
                    style: "width:362px",
                    props: {
                        multiple: true,
                        dropStyle,
                        filterable:true,
                    },
                    options: this.getLogisticStatus
                },
                {
                    label: "创建时间",
                    tag: 'vDatepicker',
                    style: "width:362px",
                    key: 'GE_createdAt',
                    props: {
                        format: 'yy-mm-dd 00:00:00~yy-mm-dd 23:59:59',
                        confirm: false,
                    },
                },
                {
                    label: "最晚发货时间",
                    tag: 'vDatepicker',
                    style: "width:362px",
                    key: 'GE_latestShipDate',
                    props: {
                        format: 'yy-mm-dd 00:00:00~yy-mm-dd 23:59:59',
                        confirm: false,
                    },
                }
            ]
        },
        getLogisticStatus(){
            return [{
                value: 'UNDELIVERED',
                label: '未投递',
            },{
                value: 'UNKNOWN',
                label: '异常',
            },{
                value: 'PRE_TRANSIT',
                label: '已创建',
            },{
                value: 'IN_TRANSIT',
                label: '在途',
            },{
                value: 'OUT_FOR_DELIVERY',
                label: '派送中',
            },{
                value: 'DELIVERED',
                label: '已妥投',
            },{
                value: 'AVAILABLE_FOR_PICKUP',
                label: '派送中',
            },{
                value: 'FAILURE',
                label: '异常',
            },{
                value: 'RETURN_TO_SENDER',
                label: '已退回',
            },{
                value: 'CANCELLED',
                label: '已取消',
            },{
                value: 'ERROR',
                label: '异常',
            }]
        },
        columns() {
            // const logisticStatus = {
            //     "UNDELIVERED": "未投递",
            //     "UNKNOWN": "异常",
            //     "PRE_TRANSIT": "已创建",
            //     "IN_TRANSIT": "在途",
            //     "OUT_FOR_DELIVERY": "派送中",
            //     "DELIVERED": "已妥投",
            //     "AVAILABLE_FOR_PICKUP": "派送中",
            //     "RETURN_TO_SENDER": "已退回",
            //     "FAILURE": "异常",
            //     "CANCELLED": "已取消",
            //     "ERROR": "异常",
            // }
            return [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            }, {
                title: '操作',
                width: 70,
                render: this.getOperateNodes
            }, {
                title: '面单ID',
                key: 'surfaceId',
                maxWidth: 100,
                render: (h, { row }) => {
                    const { id, surfaceId, errorStatus } = row,
                        statusMap = {
                            buyError: '购买异常',
                            cancelError: '取消异常',
                            pushError: '推送异常',
                            updateError: '更新异常',
                        },
                        status = statusMap[errorStatus];
                    return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, id, 'query')}>{surfaceId}</a>
                                <a onClick={this.handleOperates.bind(this, id, 'queryBlank')}><Icon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                            <div><span v-show={status} class='color-error margin-left-5' style='border:1px solid;padding:0 5px;'>{status}</span></div>
                        </div>
                }
            },
            {
                title: '单号/平台单号',
                key: 'sfpOrderId',
                render: (h, { row }) => {
                    const { sfpOrderId, orderNo, id } = row;
                    return <div>
                        <div class="word-warp">{sfpOrderId}</div>
                        <div><a onClick={this.handleOperates.bind(this, id, 'query')}>{orderNo}</a></div>
                    </div>
                }
            },
            {
                title: '平台账号/项目',
                // key: 'sourceChannel',
                render: (h, { row }) => {
                    const { lineId } = row;
                    const { name } = this.products.find(function (item) {
                        return item.id == lineId
                    }) || {};

                    return <div>
                        <div>{row.sourceChannel}</div>
                        <div>{name}</div>
                    </div>;
                }
            },
            // {
            //     title: '项目',
            //     key: 'lineId',
            //     maxWidth: 80,
            //     render: (h, { row }) => {
            //         const { lineId } = row;
            //         const { name } = this.products.find(function (item) {
            //             return item.id == lineId
            //         }) || {};
            //         return name;
            //     }
            // },
            {
                title: '单据状态',
                key: 'orderStatus',
                maxWidth: 80,
                render: (h, { row }) => {
                    const status = row.orderStatus;
                    const { theme, label } = this.orderStatus.find(function (item) {
                        return item.value == status
                    }) || {};
                    return <vButton ghost theme={theme} size="small" class="cursor-default width-60">{label}</vButton>
                }
            },
            {
                title: '仓库',
                key: 'orgWarehouseId',
                render: (h, { row }) => {
                    const { orgWarehouseId } = row;
                    const { title } = this.otherWarehouses.find(function (item) {
                        return item.id == orgWarehouseId
                    }) || {};
                    return title
                }
            },
            {
                title: '承运商服务',
                key: 'carrierService',
            },
            {
                title: '追踪号',
                key: 'trackingNo',
            },
            {
                title: '物流状态',
                key: 'logisticStatus',
                maxWidth: 80,
                render:(h, { row })=> this.findRenderLabel(this.getLogisticStatus,row.logisticStatus)
            },
            {
                title: '预估运费(USD)',
                key: 'estimateCost',
                maxWidth: 100,
                sortable: true
            },
            {
                title: '打印次数',
                key: 'printNum',
                maxWidth: 70,
            },
            {
                title: '更新/最晚发货时间',
                render:(h,{row})=>{
                    return <div>
                        <div>{row.updatedAt}</div>
                        <div>{row.latestShipDate}</div>
                    </div>
                }
            },
            ];
        },

    },

};
